/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */

import * as coreHttp from "@azure/core-http";
import * as Models from "../models";
import * as Mappers from "../models/familyCreditMappers";
import * as Parameters from "../models/parameters";
import { MicrosoftConsumerSecurityClientContext } from "../microsoftConsumerSecurityClientContext";

/** Class representing a FamilyCredit. */
export class FamilyCredit {
  private readonly client: MicrosoftConsumerSecurityClientContext;

  /**
   * Create a FamilyCredit.
   * @param {MicrosoftConsumerSecurityClientContext} client Reference to the service client.
   */
  constructor(client: MicrosoftConsumerSecurityClientContext) {
    this.client = client;
  }

  /**
   * Retrieves the credit summary for the requested member (csid).
   * @summary Retrieves the credit summary for the requested member (csid).
   * @param csid
   * @param [options] The optional parameters
   * @returns Promise<Models.FamilyCreditGetCreditSummaryResponse>
   */
  getCreditSummary(csid: string, options?: coreHttp.RequestOptionsBase): Promise<Models.FamilyCreditGetCreditSummaryResponse>;
  /**
   * @param csid
   * @param callback The callback
   */
  getCreditSummary(csid: string, callback: coreHttp.ServiceCallback<Models.CreditSummary>): void;
  /**
   * @param csid
   * @param options The optional parameters
   * @param callback The callback
   */
  getCreditSummary(csid: string, options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<Models.CreditSummary>): void;
  getCreditSummary(csid: string, options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<Models.CreditSummary>, callback?: coreHttp.ServiceCallback<Models.CreditSummary>): Promise<Models.FamilyCreditGetCreditSummaryResponse> {
    return this.client.sendOperationRequest(
      {
        csid,
        options
      },
      getCreditSummaryOperationSpec,
      callback) as Promise<Models.FamilyCreditGetCreditSummaryResponse>;
  }

  /**
   * Update the credit monitoring alert for the family member.
   * @summary Update the credit monitoring alert for the family member.
   * @param csid
   * @param id
   * @param [options] The optional parameters
   * @returns Promise<Models.FamilyCreditUpdateCreditMonitoringAlertResponse>
   */
  updateCreditMonitoringAlert(csid: string, id: string, options?: Models.FamilyCreditUpdateCreditMonitoringAlertOptionalParams): Promise<Models.FamilyCreditUpdateCreditMonitoringAlertResponse>;
  /**
   * @param csid
   * @param id
   * @param callback The callback
   */
  updateCreditMonitoringAlert(csid: string, id: string, callback: coreHttp.ServiceCallback<Models.CreditAlert>): void;
  /**
   * @param csid
   * @param id
   * @param options The optional parameters
   * @param callback The callback
   */
  updateCreditMonitoringAlert(csid: string, id: string, options: Models.FamilyCreditUpdateCreditMonitoringAlertOptionalParams, callback: coreHttp.ServiceCallback<Models.CreditAlert>): void;
  updateCreditMonitoringAlert(csid: string, id: string, options?: Models.FamilyCreditUpdateCreditMonitoringAlertOptionalParams | coreHttp.ServiceCallback<Models.CreditAlert>, callback?: coreHttp.ServiceCallback<Models.CreditAlert>): Promise<Models.FamilyCreditUpdateCreditMonitoringAlertResponse> {
    return this.client.sendOperationRequest(
      {
        csid,
        id,
        options
      },
      updateCreditMonitoringAlertOperationSpec,
      callback) as Promise<Models.FamilyCreditUpdateCreditMonitoringAlertResponse>;
  }

  /**
   * Retrieves the credit alert for the requested member (csid).
   * @summary Retrieves the credit alert for the requested member (csid).
   * @param csid
   * @param id
   * @param [options] The optional parameters
   * @returns Promise<Models.FamilyCreditGetCreditAlertByIdResponse>
   */
  getCreditAlertById(csid: string, id: string, options?: coreHttp.RequestOptionsBase): Promise<Models.FamilyCreditGetCreditAlertByIdResponse>;
  /**
   * @param csid
   * @param id
   * @param callback The callback
   */
  getCreditAlertById(csid: string, id: string, callback: coreHttp.ServiceCallback<Models.CreditAlert>): void;
  /**
   * @param csid
   * @param id
   * @param options The optional parameters
   * @param callback The callback
   */
  getCreditAlertById(csid: string, id: string, options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<Models.CreditAlert>): void;
  getCreditAlertById(csid: string, id: string, options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<Models.CreditAlert>, callback?: coreHttp.ServiceCallback<Models.CreditAlert>): Promise<Models.FamilyCreditGetCreditAlertByIdResponse> {
    return this.client.sendOperationRequest(
      {
        csid,
        id,
        options
      },
      getCreditAlertByIdOperationSpec,
      callback) as Promise<Models.FamilyCreditGetCreditAlertByIdResponse>;
  }

  /**
   * Mark a recommendation as completed by setting the isCompleted flag of the recommendation to
   * true.
   * @summary Complete a recommendation.
   * @param csid
   * @param alertId
   * @param recommendationId Possible values include: 'SigninToAccountAndCheckDetails',
   * 'CheckJointOwnerOfCardOrAccount', 'ContactCreditorForMoreInformation',
   * 'StillDontRecognizeActivityFileDisputeWithExperian', 'FileADisputeWithExperian',
   * 'AppliedOrCosignedForNewServiceAccountOrLoan',
   * 'AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation', 'ContactInquirerByMail',
   * 'ContactInquirerCompany', 'ContactIdentityValidatorCompany', 'ContactCompanyForMoreInformation',
   * 'SSNTrace', 'CreditFileLocked', 'CreditFileUnlocked', 'CreditFileUnlockedDueToMembershipChange',
   * 'InquiryBlocked', 'ContactExperianCreditLockStatus',
   * 'AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity'
   * @param [options] The optional parameters
   * @returns Promise<Models.FamilyCreditCompleteRecommendationResponse>
   */
  completeRecommendation(csid: string, alertId: string, recommendationId: Models.CreditRecommendationType, options?: Models.FamilyCreditCompleteRecommendationOptionalParams): Promise<Models.FamilyCreditCompleteRecommendationResponse>;
  /**
   * @param csid
   * @param alertId
   * @param recommendationId Possible values include: 'SigninToAccountAndCheckDetails',
   * 'CheckJointOwnerOfCardOrAccount', 'ContactCreditorForMoreInformation',
   * 'StillDontRecognizeActivityFileDisputeWithExperian', 'FileADisputeWithExperian',
   * 'AppliedOrCosignedForNewServiceAccountOrLoan',
   * 'AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation', 'ContactInquirerByMail',
   * 'ContactInquirerCompany', 'ContactIdentityValidatorCompany', 'ContactCompanyForMoreInformation',
   * 'SSNTrace', 'CreditFileLocked', 'CreditFileUnlocked', 'CreditFileUnlockedDueToMembershipChange',
   * 'InquiryBlocked', 'ContactExperianCreditLockStatus',
   * 'AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity'
   * @param callback The callback
   */
  completeRecommendation(csid: string, alertId: string, recommendationId: Models.CreditRecommendationType, callback: coreHttp.ServiceCallback<Models.CreditAlert>): void;
  /**
   * @param csid
   * @param alertId
   * @param recommendationId Possible values include: 'SigninToAccountAndCheckDetails',
   * 'CheckJointOwnerOfCardOrAccount', 'ContactCreditorForMoreInformation',
   * 'StillDontRecognizeActivityFileDisputeWithExperian', 'FileADisputeWithExperian',
   * 'AppliedOrCosignedForNewServiceAccountOrLoan',
   * 'AppliedOrCosignedForNewServiceAccountOrLoanOrAuthorizedValidation', 'ContactInquirerByMail',
   * 'ContactInquirerCompany', 'ContactIdentityValidatorCompany', 'ContactCompanyForMoreInformation',
   * 'SSNTrace', 'CreditFileLocked', 'CreditFileUnlocked', 'CreditFileUnlockedDueToMembershipChange',
   * 'InquiryBlocked', 'ContactExperianCreditLockStatus',
   * 'AppliedOrCosignedForNewServiceAccountOrLoanAndAskedToValidateIdentity'
   * @param options The optional parameters
   * @param callback The callback
   */
  completeRecommendation(csid: string, alertId: string, recommendationId: Models.CreditRecommendationType, options: Models.FamilyCreditCompleteRecommendationOptionalParams, callback: coreHttp.ServiceCallback<Models.CreditAlert>): void;
  completeRecommendation(csid: string, alertId: string, recommendationId: Models.CreditRecommendationType, options?: Models.FamilyCreditCompleteRecommendationOptionalParams | coreHttp.ServiceCallback<Models.CreditAlert>, callback?: coreHttp.ServiceCallback<Models.CreditAlert>): Promise<Models.FamilyCreditCompleteRecommendationResponse> {
    return this.client.sendOperationRequest(
      {
        csid,
        alertId,
        recommendationId,
        options
      },
      completeRecommendationOperationSpec,
      callback) as Promise<Models.FamilyCreditCompleteRecommendationResponse>;
  }
}

// Operation Specifications
const serializer = new coreHttp.Serializer(Mappers);
const getCreditSummaryOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/credit/family/members/{csid}/summary",
  urlParameters: [
    Parameters.csid
  ],
  responses: {
    200: {
      bodyMapper: Mappers.CreditSummary
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const updateCreditMonitoringAlertOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "PATCH",
  path: "api/v1/credit/family/members/{csid}/alerts/{id}",
  urlParameters: [
    Parameters.csid,
    Parameters.id
  ],
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.CreditAlertRequest
  },
  contentType: "application/json-patch+json; charset=utf-8",
  responses: {
    200: {
      bodyMapper: Mappers.CreditAlert
    },
    404: {
      bodyMapper: Mappers.CreditAlert
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const getCreditAlertByIdOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/credit/family/members/{csid}/alerts/{id}",
  urlParameters: [
    Parameters.csid,
    Parameters.id
  ],
  responses: {
    200: {
      bodyMapper: Mappers.CreditAlert
    },
    404: {
      bodyMapper: Mappers.CreditAlert
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const completeRecommendationOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "PATCH",
  path: "api/v1/credit/family/members/{csid}/alerts/{alertId}/{recommendationId}",
  urlParameters: [
    Parameters.csid,
    Parameters.alertId,
    Parameters.recommendationId1
  ],
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.ResolveRecommendationRequest
  },
  contentType: "application/json-patch+json; charset=utf-8",
  responses: {
    200: {
      bodyMapper: Mappers.CreditAlert
    },
    404: {
      bodyMapper: Mappers.CreditAlert
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};
